import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.css"],
})
export class TopNavComponent implements OnInit {
  @Input() userDetail;
  @Input() status;
  @Output() sideNavStatus: EventEmitter<boolean> = new EventEmitter();
  isSideNav: boolean = false;
  isMenuShow: boolean = false;

  constructor(private tokenservice: TokenService, private router: Router) {}

  ngOnInit() {
    console.log(JSON.stringify(this.userDetail));
  }

  logout() {
    this.tokenservice.clearStorage();
    this.router.navigate(["/auth"]);
    // location.reload();
  }

  ngOnChanges() {
    this.isSideNav = this.status;
  }

  changeSideNavStatus() {
    if (this.isSideNav == false) {
      this.isSideNav = true;
      this.sideNavStatus.emit(this.isSideNav);
    } else {
      this.isSideNav = false;
      this.sideNavStatus.emit(this.isSideNav);
    }
  }

  menuDisplay() {
    if (this.isMenuShow) {
      this.isMenuShow = false;
      return;
    } else {
      this.isMenuShow = true;
      return;
    }
  }
}
